import React from 'react';
import emailBlockBgDark from '../assets/png/email_block_bg-dark.png';

const HelpCenterBlock: React.FC = () => {
  return (
    <div className="relative w-full md:w-[508px] h-auto md:h-[158px]">
      <div className="relative h-full border border-contrast-7 dark:border-contrast-3 rounded-lg bg-white/50 dark:bg-contrast-2 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-azul/5 via-transparent to-transparent" />
        
        {/* Background texture for dark mode - positioned on bottom */}
        <div 
          className="hidden dark:block absolute h-full bottom-0 opacity-30"
          style={{
            backgroundImage: `url(${emailBlockBgDark})`,
            backgroundSize: 'auto 100%',
            backgroundPosition: 'right -8px top -8px',
            backgroundRepeat: 'no-repeat',
            width: '100%',
            left: '50%',
            transform: 'translateX(-50%)'
          }}
        />
        
        {/* Content wrapper with proper padding */}
        <div className="relative px-4 md:px-6 py-6 md:py-[35px] h-full flex flex-col md:flex-row items-start md:items-center justify-between gap-4 md:gap-0">
          {/* Left side - Text content */}
          <div className="flex flex-col gap-3 w-full md:w-[263px]">
            <h3 className="text-contrast-3 dark:text-contrast-8 text-[16px] md:text-[18px] font-medium font-geist">
              Learn More
            </h3>
            <p className="text-contrast-4 dark:text-contrast-6 text-[12px] font-geist leading-[18px]">
              👉 Visit our <span className="">Help Center</span> to learn more about the VLR staking system.
            </p>
          </div>
          
          {/* Right side - Button */}
          <button 
            onClick={() => window.open('https://help.velora.xyz/', '_blank')}
            className="bg-contrast-8 dark:bg-contrast-3 h-10 px-4 py-2.5 rounded-[6px] text-contrast-4 dark:text-contrast-7 text-[14px] font-medium font-inter hover:bg-contrast-7 dark:hover:bg-contrast-1 transition-all flex items-center gap-[3px] w-full md:w-auto justify-center md:justify-start cursor-pointer"
          >
            Start Exploring
            <svg className="w-3.5 h-3.5" viewBox="0 0 14 14" fill="none">
              <path d="M2 7h10M7 2l5 5-5 5" stroke="currentColor" strokeWidth="1.5"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default HelpCenterBlock;